import { render, staticRenderFns } from "./Emphasize.vue?vue&type=template&id=7856685a"
import script from "./Emphasize.vue?vue&type=script&lang=js"
export * from "./Emphasize.vue?vue&type=script&lang=js"
import style0 from "./Emphasize.vue?vue&type=style&index=0&id=7856685a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports